import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { JobworkPartiesProps } from "../../types/jobworkParties";

export interface JobworkPartiesState {
  jobworkParties: JobworkPartiesProps[];
  totalJobworkParties: number;
  totalPendingAmount: number;
  totalReceivedAmount: number;
  isJobworkPartyModalOpen: boolean;
  editJobworkParty: JobworkPartiesProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: JobworkPartiesState = {
  jobworkParties: [],
  totalJobworkParties: 0,
  totalPendingAmount: 0,
  totalReceivedAmount: 0,
  isJobworkPartyModalOpen: false,
  editJobworkParty: null,
  loading: false,
  error: null,
};

type FetchJobworkPartiesListDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  search?: string | null;
};

export const fetchJobworkPartiesListData = createAsyncThunk(
  "fetchJobworkPartiesListData",
  async (req: FetchJobworkPartiesListDataProps) => {
    let response: any;
    await GET(`/v1/admin/jobwork-parties`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const jobworkPartiesSlice = createSlice({
  name: "jobworkParties",
  initialState,
  reducers: {
    toggleJobworkPartyModal: (state, action: PayloadAction<boolean>) => {
      state.isJobworkPartyModalOpen = action.payload;
    },
    setEditJobworkParty: (state, action: PayloadAction<JobworkPartiesProps | null>) => {
      state.editJobworkParty = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchJobworkPartiesListData.pending, (state, action: any) => {
      state.jobworkParties = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchJobworkPartiesListData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.jobworkParties = action.payload.data.data.records;
        state.totalJobworkParties = action.payload.data.data.total_records;
        state.totalPendingAmount =
          action.payload.data.data.total_pending_amount;
        state.totalReceivedAmount =
          action.payload.data.data.total_received_amount;
        state.error = null;
      } else {
        state.jobworkParties = [];
        state.totalPendingAmount = 0;
        state.totalReceivedAmount = 0;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchJobworkPartiesListData.rejected, (state, action: any) => {
      state.jobworkParties = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { toggleJobworkPartyModal, setEditJobworkParty } = jobworkPartiesSlice.actions;

export const getJobworkParties = (state: RootState) => state.jobworkParties.jobworkParties;

export const getTotalJobworkParties = (state: RootState) => state.jobworkParties.totalJobworkParties;

export const getTotalPendingAmount = (state: RootState) =>
  state.jobworkParties.totalPendingAmount;

export const getTotalReceivedAmount = (state: RootState) =>
  state.jobworkParties.totalReceivedAmount;

export const getIsJobworkPartyModalOpen = (state: RootState) =>
  state.jobworkParties.isJobworkPartyModalOpen;

export const getEditJobworkParty = (state: RootState) => state.jobworkParties.editJobworkParty;

export default jobworkPartiesSlice.reducer;
